module.exports = __webpack_public_path__ + "static/img/titlehead.3c65153.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/kpi/titlehead.jpeg
// module id = e51+
// module chunks = 4